import React from 'react';
import { Link } from 'react-router-dom';
import LogoImage from '../assets/puraorgaicLogoDemo.png'

const Footer = () => {
    return (
        <footer className="w-full bg-[#0000002B] py-12 px-4 md:px-8 lg:px-12">
            <div className="w-full mx-auto">
                {/* Main Footer Content */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
                    {/* Brand Info */}
                    <div className="flex flex-col items-start">
                        <div className="flex items-center mb-4">
                            <img src={LogoImage} className="h-16" alt='Logo' />
                            {/* <span className="text-2xl font-bold text-gray-800">
                                organico
                            </span> */}
                        </div>
                        <p className="text-gray-700 text-sm leading-relaxed mb-6 max-w-xs">
                            After searching endlessly for truly pure, chemical-free food, we realized the only way to get it was to create it ourselves.
                        </p>
                        {/* <div className="flex space-x-3">
                            <a 
                                href="https://www.instagram.com/puraorganico" 
                                target='_blank' 
                                rel="noopener noreferrer"
                                className="bg-blue-600 p-2 rounded text-white hover:bg-blue-700 transition-colors"
                            >
                                <FontAwesomeIcon icon={faInstagram} className="w-4 h-4" />
                            </a>
                            <a 
                                href="https://api.whatsapp.com/send?phone=7020835050" 
                                target='_blank' 
                                rel="noopener noreferrer"
                                className="bg-blue-600 p-2 rounded text-white hover:bg-blue-700 transition-colors"
                            >
                                <FontAwesomeIcon icon={faWhatsapp} className="w-4 h-4" />
                            </a>
                        </div> */}
                    </div>

                    {/* Quick Links */}
                    <div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-4">Quick Link</h3>
                        <ul className="space-y-3">
                            <li><Link to="/" className="text-gray-700 hover:text-blue-600 transition-colors text-sm">Home</Link></li>
                            <li><Link to="/shop" className="text-gray-700 hover:text-blue-600 transition-colors text-sm">Shop</Link></li>
                            <li><Link to="/about" className="text-gray-700 hover:text-blue-600 transition-colors text-sm">About Us</Link></li>
                            <li><Link to="/blogs" className="text-gray-700 hover:text-blue-600 transition-colors text-sm">Blog</Link></li>
                        </ul>
                    </div>

                    {/* Categories */}
                    {/* <div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-4">Categories</h3>
                        <ul className="space-y-3">
                            <li><Link to="/shop" className="text-gray-700 hover:text-blue-600 transition-colors text-sm">Honey</Link></li>
                            <li><Link to="/shop" className="text-gray-700 hover:text-blue-600 transition-colors text-sm">Ghee</Link></li>
                            <li><Link to="/shop" className="text-gray-700 hover:text-blue-600 transition-colors text-sm">Turmeric</Link></li>
                        </ul>
                    </div> */}

                    {/* Contact Info */}
                    <div>
                        <h3 className="text-lg font-semibold text-gray-800 mb-4">Contact Us</h3>
                        <ul className="space-y-3 text-gray-700 text-sm">
                            <li>6th Floor, Landmark building,
                                Ramdaspeth, Nagpur, Maharashtra
                                440012</li>
                            <li>info@puraorganico.com</li>
                            <li>+91 7020835050</li>
                            <li>Mon - Sat : 9AM - 6PM</li>
                        </ul>
                    </div>
                </div>

                {/* Divider */}
                <div className="border-t border-gray-300 my-6"></div>

                {/* Copyright & Bottom Bar */}
                <div className="flex flex-col md:flex-row justify-between border-t py-2 border-[#FF7D13] items-center text-sm">
                    <p className="text-gray-600 mb-4 md:mb-0">
                        © {new Date().getFullYear()} Pura Organico. All rights reserved.
                    </p>
                    <div className="flex space-x-6">
                        <Link to="/contact" className="text-gray-600 hover:text-blue-600 transition-colors">Privacy Policy</Link>
                        <Link to="/contact" className="text-gray-600 hover:text-blue-600 transition-colors">Terms of Service</Link>
                        <Link to="/contact" className="text-gray-600 hover:text-blue-600 transition-colors">Shipping Policy</Link>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;